/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateSession200Response } from '../models';
// @ts-ignore
import type { CreateSession401Response } from '../models';
// @ts-ignore
import type { CreateSession500Response } from '../models';
// @ts-ignore
import type { GetSessionStatus200Response } from '../models';
// @ts-ignore
import type { InvalidateSession200Response } from '../models';
// @ts-ignore
import type { InvalidateSession500Response } from '../models';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다. AuthServer 의존성 없이 독립적으로 세션을 관리합니다. 
         * @summary JWT 토큰으로 새로운 세션 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/create-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다. 세션 정보와 JWT 토큰 정보를 모두 반환합니다. 
         * @summary 현재 세션 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/session-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 현재 HTTP 세션을 무효화합니다. 로그아웃 처리에 사용됩니다. 
         * @summary 세션 무효화 (로그아웃)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateSession: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/auth/invalidate-session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다. AuthServer 의존성 없이 독립적으로 세션을 관리합니다. 
         * @summary JWT 토큰으로 새로운 세션 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.createSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다. 세션 정보와 JWT 토큰 정보를 모두 반환합니다. 
         * @summary 현재 세션 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSessionStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetSessionStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSessionStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.getSessionStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 현재 HTTP 세션을 무효화합니다. 로그아웃 처리에 사용됩니다. 
         * @summary 세션 무효화 (로그아웃)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invalidateSession(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvalidateSession200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invalidateSession(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.invalidateSession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다. AuthServer 의존성 없이 독립적으로 세션을 관리합니다. 
         * @summary JWT 토큰으로 새로운 세션 생성
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSession(options?: RawAxiosRequestConfig): AxiosPromise<CreateSession200Response> {
            return localVarFp.createSession(options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다. 세션 정보와 JWT 토큰 정보를 모두 반환합니다. 
         * @summary 현재 세션 상태 확인
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSessionStatus(options?: RawAxiosRequestConfig): AxiosPromise<GetSessionStatus200Response> {
            return localVarFp.getSessionStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 HTTP 세션을 무효화합니다. 로그아웃 처리에 사용됩니다. 
         * @summary 세션 무효화 (로그아웃)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invalidateSession(options?: RawAxiosRequestConfig): AxiosPromise<InvalidateSession200Response> {
            return localVarFp.invalidateSession(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - interface
 * @export
 * @interface AuthApi
 */
export interface AuthApiInterface {
    /**
     * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다. AuthServer 의존성 없이 독립적으로 세션을 관리합니다. 
     * @summary JWT 토큰으로 새로운 세션 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    createSession(options?: RawAxiosRequestConfig): AxiosPromise<CreateSession200Response>;

    /**
     * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다. 세션 정보와 JWT 토큰 정보를 모두 반환합니다. 
     * @summary 현재 세션 상태 확인
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    getSessionStatus(options?: RawAxiosRequestConfig): AxiosPromise<GetSessionStatus200Response>;

    /**
     * 현재 HTTP 세션을 무효화합니다. 로그아웃 처리에 사용됩니다. 
     * @summary 세션 무효화 (로그아웃)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApiInterface
     */
    invalidateSession(options?: RawAxiosRequestConfig): AxiosPromise<InvalidateSession200Response>;

}

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI implements AuthApiInterface {
    /**
     * 유효한 JWT 토큰을 사용하여 Pay 서버에서 새로운 HTTP 세션을 생성합니다. AuthServer 의존성 없이 독립적으로 세션을 관리합니다. 
     * @summary JWT 토큰으로 새로운 세션 생성
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public createSession(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).createSession(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 HTTP 세션과 JWT 인증 상태를 확인합니다. 세션 정보와 JWT 토큰 정보를 모두 반환합니다. 
     * @summary 현재 세션 상태 확인
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public getSessionStatus(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).getSessionStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 현재 HTTP 세션을 무효화합니다. 로그아웃 처리에 사용됩니다. 
     * @summary 세션 무효화 (로그아웃)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public invalidateSession(options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).invalidateSession(options).then((request) => request(this.axios, this.basePath));
    }
}

